export var ELongitudinalSlopeType;
(function (ELongitudinalSlopeType) {
    ELongitudinalSlopeType["FLAT"] = "flat";
    ELongitudinalSlopeType["CONSTANT"] = "constant";
    ELongitudinalSlopeType["DEFAULT"] = "default";
    ELongitudinalSlopeType["NONE"] = "none";
})(ELongitudinalSlopeType || (ELongitudinalSlopeType = {}));
export var ERubbingDestination;
(function (ERubbingDestination) {
    ERubbingDestination["POINT_CLOUD"] = "pointcloud";
    ERubbingDestination["DESIGN_DATA"] = "design";
    ERubbingDestination["FLAT_GROUND"] = "flatground";
    ERubbingDestination["SPECIFIED_ALTITUDE"] = "specified-altitude";
    ERubbingDestination["REFERENCE_TOPOLOGY"] = "reference-topology";
})(ERubbingDestination || (ERubbingDestination = {}));
//# sourceMappingURL=types.js.map